/**
 * @param {Headers} [headers]
 *
 * @return {Headers} Headers including JSON content type
 */
export default function getJSONHeaders(headers) {
  headers = headers || new Headers();
  headers.append("Content-Type", "application/json;charset=utf-8");

  return headers;
}
